// extracted by mini-css-extract-plugin
module.exports = {"container":"Projects-module--container--3ZJKp","heading":"Projects-module--heading--17zn2"};